const OTHER_SLIDE_KEY_RE = /^slide_\d+_/;

const visualSlideNumber = ({ slideIndex } = {}) => {
  const index = Number(slideIndex);
  if (!Number.isInteger(index) || index < 0) return 0;
  return index + 1;
};

export const buildProduceVariableKey = ({
  slideIndex,
  variable,
  isCarousel,
} = {}) => {
  const key = String(variable || "").trim();
  if (!key) return "";
  if (isCarousel === false) return key;
  const visual = visualSlideNumber({ slideIndex });
  return visual ? `slide_${visual}_${key}` : key;
};

export const parseProduceVariableKey = ({ key } = {}) => {
  const raw = String(key || "").trim();
  const match = raw.match(/^slide_(\d+)_(.+)$/);
  if (!match) return { slideIndex: -1, variable: raw };
  return {
    slideIndex: Number(match[1]) - 1,
    variable: match[2],
  };
};

export const projectProduceRowForSlide = ({ row = {}, slideIndex } = {}) => {
  const visual = visualSlideNumber({ slideIndex });
  if (!visual) return { ...(row || {}) };
  const prefix = `slide_${visual}_`;
  const projected = {};
  Object.entries(row || {}).forEach(([key, value]) => {
    if (key.startsWith(prefix) || OTHER_SLIDE_KEY_RE.test(key)) return;
    projected[key] = value;
  });
  Object.entries(row || {}).forEach(([key, value]) => {
    if (!key.startsWith(prefix)) return;
    projected[key] = value;
    projected[key.slice(prefix.length)] = value;
  });
  return projected;
};
